import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from './../shared/guard/auth.guard';
import { OrdersResolver } from './orders.resolver';
import { UserResolver } from './user.resolver';
import { AutofillEligibilityResolver } from './autofill-eligibility.resolver';
const ɵ0 = () => import("./orders-tab/orders-tab.module.ngfactory").then(m => m.OrdersTabModuleNgFactory), ɵ1 = {
    tab: true,
    default: true,
    label: {
        name: 'orders',
        ariaLabel: '',
        dynValue: ''
    }
}, ɵ2 = () => import("./medications-tab/medications-tab.module.ngfactory").then(m => m.MedicationsTabModuleNgFactory), ɵ3 = {
    tab: true,
    label: {
        name: 'medications',
        ariaLabel: '',
        dynValue: ''
    }
}, ɵ4 = () => import("./settings-tab/settings-tab.module.ngfactory").then(m => m.SettingsTabModuleNgFactory), ɵ5 = {
    tab: true,
    label: {
        name: 'settings',
        ariaLabel: '',
        dynValue: ''
    }
}, ɵ6 = () => import("./order-details/order-details.module.ngfactory").then(m => m.OrderDetailsModuleNgFactory), ɵ7 = {
    hidetabs: false
}, ɵ8 = () => import("./order-details/order-details.module.ngfactory").then(m => m.OrderDetailsModuleNgFactory), ɵ9 = () => import("./order-item-details/order-item-details.module.ngfactory").then(m => m.OrderItemDetailsModuleNgFactory), ɵ10 = () => import("./order-item-details/order-item-details.module.ngfactory").then(m => m.OrderItemDetailsModuleNgFactory), ɵ11 = () => import("./order-history/order-history.module.ngfactory").then(m => m.OrderHistoryModuleNgFactory), ɵ12 = () => import("./order-history-details/order-history-details.module.ngfactory").then(m => m.OrderHistoryDetailsModuleNgFactory), ɵ13 = () => import("./sync-plan/sync-plan.module.ngfactory").then(m => m.SyncPlanModuleNgFactory), ɵ14 = () => import("./autofill-enrollment/autofill-enrollment.module.ngfactory").then(m => m.AutofillEnrollmentModuleNgFactory), ɵ15 = {
    title: 'CVS Pharmacy | Multi Dose Packaging Dashboard AutoFill Options'
};
export const routes = [
    {
        path: '',
        component: DashboardComponent,
        resolve: {
            user: UserResolver,
            orders: OrdersResolver,
            autofill: AutofillEligibilityResolver
        },
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: 'orders',
                loadChildren: ɵ0,
                canActivate: [AuthGuard],
                data: ɵ1
            },
            {
                path: 'medications',
                loadChildren: ɵ2,
                canActivate: [AuthGuard],
                data: ɵ3
            },
            {
                path: 'settings',
                loadChildren: ɵ4,
                canActivate: [AuthGuard],
                data: ɵ5
            },
            {
                path: 'order-details',
                loadChildren: ɵ6,
                canActivate: [AuthGuard],
                data: ɵ7
            },
            {
                path: 'order-details/:orderId/:status',
                loadChildren: ɵ8,
                canActivate: [AuthGuard]
            },
            {
                path: 'medication-details/:orderId/:status/:rxNumber',
                loadChildren: ɵ9,
                canActivate: [AuthGuard]
            },
            {
                path: 'order-details/:orderId/:status/:rxNumber',
                loadChildren: ɵ10,
                canActivate: [AuthGuard]
            },
            {
                path: 'order-history',
                loadChildren: ɵ11,
                canActivate: [AuthGuard]
            },
            {
                path: 'order-history/:orderId/:status',
                loadChildren: ɵ12,
                canActivate: [AuthGuard]
            },
            {
                path: 'sync-plan',
                loadChildren: ɵ13,
                canActivate: [AuthGuard]
            },
            {
                path: 'autofill',
                loadChildren: ɵ14,
                canActivate: [AuthGuard],
                data: ɵ15
            },
            {
                path: '',
                redirectTo: '',
                pathMatch: 'full'
            }
        ]
    }
];
export class DashboardRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15 };
